"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatDate_1 = require("@/util/formatDate");
function PostItem(posts) {
    return posts
        .map((post) => `
    <a href="${post.path}" data-link class="group block py-5 border-t border-solid border-line">
      <div class="text-caption2-bold font-GmarketSansMedium text-accent">${post.category} · ${(0, formatDate_1.formatDate)(post.date)}</div>
      <h4 class="mt-2 text-subTitle font-GmarketSansMedium text-white-200 group-hover:text-accent">${post.title}</h4>
      <p class="mt-2 text-caption1 text-muted">${post.description}</p>
    </a>
  `)
        .join("");
}
exports.default = PostItem;
